import { render, staticRenderFns } from "./JLproject.vue?vue&type=template&id=e74bf77a&scoped=true"
import script from "./JLproject.vue?vue&type=script&lang=js"
export * from "./JLproject.vue?vue&type=script&lang=js"
import style0 from "./JLproject.vue?vue&type=style&index=0&id=e74bf77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74bf77a",
  null
  
)

export default component.exports